import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CardService } from './card.service';
import { CopyConfigurationModule } from './copy-configuration/copy-configuration.module';
import { ModifyCardModule } from './modify-card/modify-card.module';
import { ViewCardsModule } from './view-cards/view-cards.module';

@NgModule({
  imports: [
    CommonModule,
    CopyConfigurationModule,
    ModifyCardModule,
    ViewCardsModule
  ],
  providers: [
    CardService
  ],
})

export class CardModule {}



// WEBPACK FOOTER //
// /app/src/app/hq/cards/card.module.ts